export default __webpack_public_path__ + "static/media/calendar.10454c98.svg";